import { put } from "db/api";

export const updateSubscription = async (id, body) => {
  try {
    const response = await put("/update-subscription/" + id, body);
    const data = await response.json();

    if (!response.ok) {
      console.error("Error en la función:", data.error);
      return;
    }
  } catch (error) {
    console.error("Error inesperado:", error.message);
  }
};
